import { SideBarMenu } from "./SideBarMenu";
import { SideBarMenuItem } from "./SideBarMenuItem";

class MenuUtils {
    constructor() {
        this.menu = new SideBarMenu("MainMenu", "MainMenu", [
            new SideBarMenuItem(
                "Dashboard",
                "Pages.Administration.Host.Dashboard",
                "example",
                "/dashboard/hostdashboard"
            ),
            new SideBarMenuItem(
                "Dashboard",
                "Pages.Tenant.Dashboard",
                "example",
                "/dashboard/tenantdashboard"
            ),
            new SideBarMenuItem("初始化导航", "Pages.InitSetting", "init", "initialization", [
                new SideBarMenuItem(
                    "PurchasedModuleUser",
                    "Pages.PurchasedModuleUser",
                    "user",
                    "/initialization/userVersion"
                ),
                new SideBarMenuItem(
                    "PurchasedModuleConfs",
                    "Pages.PurchasedModuleConfs",
                    "purchased",
                    "/initialization/purchased"
                ),
                new SideBarMenuItem(
                    "StoreAuthorizes",
                    "Pages.StoreAuthorizes",
                    "account",
                    "/initialization/storeAuthorize"
                ),
                new SideBarMenuItem(
                    "VoucherRecordViews",
                    "Pages.VoucherRecordViews",
                    "account",
                    "/initialization/voucherRecordView"
                ),
                // new SideBarMenuItem(
                //     "WorkFlowInfos",
                //     "Pages.WorkFlowInfos",
                //     "purchased",
                //     "/initialization/workFlow"
                // ),
                new SideBarMenuItem(
                    "AccountConfInfosUser",
                    "Pages.AccountConfInfosUser",
                    "account",
                    "/initialization/userAccount"
                ),
                // new SideBarMenuItem(
                //     "WorkFlowApp",
                //     "Pages.WorkFlowApp",
                //     "data",
                //     "/initialization/graph"
                // ),
            ]),
            new SideBarMenuItem("后台管理", "Pages.BackManager", "houtai", "admin", [
                new SideBarMenuItem(
                    "ERPSystemVersionInfos",
                    "Pages.ERPSystemVersionInfos",
                    "version",
                    "/admin/erp"
                ),
                new SideBarMenuItem(
                    "BussinessModules",
                    "Pages.BussinessModules",
                    "example",
                    "/admin/moduleAdmin"
                ),
                new SideBarMenuItem(
                    "VoucherControls",
                    "Pages.AccountConfInfos",
                    "admin",
                    "/admin/voucherControl"
                ),
                new SideBarMenuItem(
                    "AccountConfInfos",
                    "Pages.AccountConfInfos",
                    "admin",
                    "/admin/accountAdmin"
                ),
                new SideBarMenuItem(
                    "BasicInfoTypes",
                    "Pages.BasicDatas",
                    "form",
                    "/admin/basicInfoType"
                ),
                new SideBarMenuItem("BasicDatas", "Pages.BasicDatas", "form", "/admin/infoMenu"),
                new SideBarMenuItem(
                    "BasicFields",
                    "Pages.BasicFields",
                    "form",
                    "/admin/basicField"
                ),
                new SideBarMenuItem("ExpFields", "Pages.ExpFields", "form", "/admin/expField"),
                new SideBarMenuItem(
                    "SubjectTypes",
                    "Pages.SubjectTypes",
                    "table",
                    "/subject/subjectType"
                ),
                new SideBarMenuItem(
                    "SubjectFields",
                    "Pages.SubjectFields",
                    "text",
                    "/subject/subjectField"
                ),
                // new SideBarMenuItem(
                //     "SubjectTypeUsers",
                //     "Pages.SubjectTypeUsers",
                //     "table",
                //     "/subject/subjectTypeUser"
                // ),
                // new SideBarMenuItem(
                //     "SubjectFieldUsers",
                //     "Pages.SubjectFieldUsers",
                //     "text",
                //     "/subject/subjectFieldUser"
                // ),
                new SideBarMenuItem(
                    "SubjectDetails",
                    "Pages.SubjectDetails",
                    "subject",
                    "/voucher/subject"
                ),
                new SideBarMenuItem(
                    "SubjectExplanations",
                    "Pages.SubjectExplanations",
                    "weihu",
                    "/voucher/subjectExplanation"
                ),
                new SideBarMenuItem(
                    "SubjectRelations",
                    "Pages.SubjectRelations",
                    "relationship",
                    "/voucher/subjectrelation"
                ),
                new SideBarMenuItem(
                    "QuestionTypes",
                    "Pages.QuestionClasses",
                    "form",
                    "/helpCenter/questionClass"
                ),
                new SideBarMenuItem(
                    "QuestionAdmins",
                    "Pages.QuestionAdmins",
                    "form",
                    "/helpCenter/questionAdmin"
                ),
                new SideBarMenuItem(
                    "WorkBookAdmins",
                    "Pages.WorkBookAdmins",
                    "subject",
                    "/helpCenter/workBookAdmin"
                ),
                new SideBarMenuItem(
                    "BillTypes",
                    "Pages.BillTypes",
                    "table",
                    "/billType/billTypes"
                ),
            ]),
            new SideBarMenuItem("档案管理", "Pages.CraftingTable", "admin", "bench", [
                new SideBarMenuItem("BasicDataList", "Pages.BasicDataList", "data", "/bench/index"),
                new SideBarMenuItem(
                    "BussinessOrderManagers",
                    "Pages.BussinessOrderManagers",
                    "form",
                    "/bench/businessOrder"
                ),
            ]),
            new SideBarMenuItem("Tenants", "Pages.Tenants", "adduser", "/admin/tenants"),
            // new SideBarMenuItem(
            //     '对账表',
            //     'Pages.BussinessModules',
            //     'table',
            //     ''
            // ),

            new SideBarMenuItem("凭证系统", "Pages.Voucher", "pingzheng02", "voucher", [
                new SideBarMenuItem(
                    "VoucherCreate",
                    "Pages.VoucherCreate",
                    "shengcheng",
                    "/voucher/voucherCreate"
                ),
                new SideBarMenuItem(
                    "VoucherManage",
                    "Pages.VoucherManager",
                    "pingzheng",
                    "/voucher/voucherManager"
                ),
                new SideBarMenuItem(
                    "VoucherLogs",
                    "Pages.VoucherLogs",
                    "blogs",
                    "/voucher/voucherlogs"
                ),
                new SideBarMenuItem(
                    "HangfireVouchers",
                    "Pages.HangfireVouchers",
                    "blogs",
                    "/voucher/hangfireVoucher"
                ),
                new SideBarMenuItem(
                    "SysOpLogs",
                    "Pages.SysOpLogs",
                    "pingzheng",
                    "/voucher/sysoplogs"
                ),
                // new SideBarMenuItem("SysOpLogs", "Pages.SysOpLogs", "blogs", "/voucher/sysoplogs"),
            ]),
            // new SideBarMenuItem(
            //     '单据管理',
            //     'Pages.Order',
            //     'danju',
            //     'order',
            //     [
            //         new SideBarMenuItem(
            //             '单据同步',
            //             'Pages.OrderCreate',
            //             'shengcheng',
            //             '/order/orderCreate'
            //         ),
            //         new SideBarMenuItem(
            //             '单据管理',
            //             'Pages.OrderManager',
            //             'pingzheng',
            //             '/order/orderManager'
            //         )
            //     ]
            // ),
            new SideBarMenuItem("接口管理", "Pages.Api", "set", "api", [
                new SideBarMenuItem("ApiCheck", "Pages.ApiCheck", "shengcheng", "/api/apiCheck"),
            ]),
            new SideBarMenuItem("权限管理", "Pages.Administration", "user", "#", [
                new SideBarMenuItem("Roles", "Pages.Administration.Roles", "roles", "/admin/roles"),
                new SideBarMenuItem("Users", "Pages.Administration.Users", "user", "/admin/users"),
                new SideBarMenuItem(
                    "Languages",
                    "Pages.Administration.Languages",
                    "language",
                    "/admin/languages"
                ),
                new SideBarMenuItem(
                    "AuditLogs",
                    "Pages.Administration.AuditLogs",
                    "blogs",
                    "/admin/auditlogs"
                ),
                new SideBarMenuItem(
                    "Maintenance",
                    "Pages.Administration.Host.Maintenance",
                    "relation",
                    "/admin/maintenance"
                ),
                new SideBarMenuItem(
                    "Subscription",
                    "Pages.Administration.Tenant.SubscriptionManagement",
                    "dingyue",
                    "/admin/subscriptions"
                ),
                new SideBarMenuItem(
                    "Settings",
                    "Pages.Administration.Host.Settings",
                    "set",
                    "/admin/hostsettings"
                ),
                new SideBarMenuItem(
                    "Publishs",
                    "Pages.Administration.Host.Settings",
                    "publish",
                    "/admin/publishmanage"
                ),
            ]),
        ]);
        cf.nav.menus = this.menu;
    }

    get getMenu() {
        return this.menu;
    }
}

export default new MenuUtils();
